import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zip'
})
export class ZipPipe implements PipeTransform {
/**
 * Parses a zipcode string and adds "-" between the 5th and 6th character
 * @param value The zipe code string to be parsed
 */
  transform(value: string): string {
    if ( value.length > 5 && value.charAt(5) !== '-' ) {
      return value.slice(0, 5) + '-' + value.slice(5);
    } else if ( value.length === 6 && value.endsWith('-') ) {
      return value.slice(0, 5);
    } else {
      return value;
    }
  }
}
